import { closeModal } from "./closeModal";

export const handleCloseTriggerClick = (event, modal) => {
  event.preventDefault();
  closeModal(modal);
};
